import { DeliveryType, Api } from '.';
import { CustomTag } from '../investment';
import { InvestorCustomTag } from '../investor/schema';

export type Recipient = {
  name?: string;
  email?: string;
  type: string;
  otherUsersEmails?: Array<string>;
  disableAllEmails?: boolean;
};

export interface GetNumberOfRecipientsToSendUpdateResponse {
  numberOfRecipients: number;
  recipients: Array<Recipient>;
}

export interface CustomUpdateAttachment {
  title: string;
  url: string;
  preview?: string;
}

export interface GetCustomUpdateResponse {
  customUpdate: {
    _id: string;
    numberOfRecipients?: number;
    funds?: Array<{
      fundName?: string;
    }>;
    companies?: Array<{
      tradingName?: string | null;
      shareClass?: string | null;
    }>;
    title?: string | null;
    subject?: string | null;
    emailBody?: string | null;
    attachments: Array<CustomUpdateAttachment>;
  };
}

export interface GetNumberOfRecipientsToSendUpdateRequest {
  companyId: Array<string>;
  trancheId: Array<string>;
  sendToDirectInvestors: boolean;
  sendToAdvisedInvestors: boolean;
  sendToAdvisers: boolean;
  sendToOrganisations: boolean;
  sendToAllUsers: boolean;
  sendToAllUsersWithSubscriptions: boolean;
  sendToAllUsersWithNoSubscriptions: boolean;
  firmId: string;
  investorIds: Array<string>;
  allocationIds: Array<string>;
  recipientFilter: Api.RecipientFilter;
  customTags: Array<CustomTag | InvestorCustomTag>;
}

export interface CreateCustomUpdateRequest
  extends GetNumberOfRecipientsToSendUpdateRequest {
  title: string;
  subject: string;
  emailBody: string;
  recipientFilter: RecipientFilter;
  deliveryToInvestors: DeliveryType;
  accountManager?: {
    _id: string;
    name: string;
  };
  role?: string;
  attachments: Array<CustomUpdateAttachment>;
  status: Status;
  notifyRecipientsOnEdit: boolean;
  includeFinancialPromotionsNotice: boolean;
  financialPromotionsLearnMoreUrl: string;
}

export interface UpdateCustomUpdateRequest extends CreateCustomUpdateRequest {
  _id: string;
}

export type DeleteCustomUpdateResponse = {
  _id: string;
};

export type GetCustomUpdateRequest = GetCustomUpdateResponse;
export type CreateCustomUpdateResponse = GetCustomUpdateResponse;
export type UpdateCustomUpdateResponse = GetCustomUpdateResponse;

export enum RecipientFilter {
  Company = 'company',
  Tranche = 'tranche',
  Specific = 'specific',
  Subscriptions = 'subscriptions',
  NoSubscriptions = 'noSubscriptions',
  All = 'all',
  SubscriptionCustomTags = 'subscriptionCustomTags',
  InvestorCustomTags = 'investorCustomTags',
}

export enum Status {
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED',
}
